<template>
  <div>
    <div class="wreppar">
      <div>
        <Header></Header>
      </div>
      <div class="centent">
        <div class="centent_child">
          <div class="section">
            <div class="re_dian">
              <p class="dian_shi">热点赛事</p>
              <p class="dian_wen">MORE</p>
            </div>
            <div class="dian_center">
              <div class="dian_lie" v-for="(item,index) in matchData">
                <div class="lie_img">
                  <img :src="item.image.substring(2,item.image.length-2)" alt />
                </div>
                <p @click="details(index)">{{item.title}}</p>
              </div>
            </div>
          </div>
          <div class="centent_right">
            <div class="centent_title">{{ajaxData.title}}</div>
            <div v-html="ajaxData.content" class="centent_nei"></div>
          </div>
        </div>
      </div>
      <div>
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../header/header.vue";
import Footer from "../footer/footer.vue";
export default {
  data() {
    return {
      matchData: [],
      ajaxData: [],
      page: "",
      pageSize: "6"
    };
  },
  components: { Header, Footer },
  watch: {},
  methods: {
    games_app: function() {
      const rLoading = this.openLoading();
      let that = this;
      that.$http
        .get(
          that.g.ajaxurl +
            "attentions/indexw?page=" +
            that.page +
            "&pageSize=" +
            that.pageSize
        )
        .then(res => {
          console.log(res);
          that.matchData = res.data.data.items;
          rLoading.close();
        });
    },
    details: function(a) {
      let that = this;
      that.$http
        .get(
          that.g.ajaxurl + "attentions/event?eventid=" + this.matchData[a].id
        )
        .then(res => {
          that.ajaxData = res.data.data;
        });
    }
  },
  mounted() {
    const rLoading = this.openLoading();
    let that = this;
    that.$http
      .get(that.g.ajaxurl + "attentions/event?eventid=" + this.$route.query.id)
      .then(res => {
        that.ajaxData = res.data.data;
        rLoading.close();
      });
    this.games_app();
  }
};
</script>
<style scoped="scoped">
* {
  margin: 0;
  padding: 0;
}
.wreppar {
  width: 100%;
}
.centent {
  width: 100%;
  padding-top: 2rem;
}
.centent_child {
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
}
.section {
  width: 30%;
}
.re_dian {
  width: 100%;
  border-bottom: solid 2px #e50005;
  display: flex;
  justify-content: space-between;
}
.dian_shi {
  font-size: 0.2rem;
  background: #e50005;
  line-height: 0.4rem;
  color: #fff;
  padding: 0 0.3rem;
  border-radius: 5px 5px 0 0;
}
.dian_wen {
  font-size: 0.2rem;
  color: #e50005;
  line-height: 0.4rem;
}
.dian_center {
  width: 100%;
}
.dian_lie {
  display: flex;
  justify-content: flex-start;
  border-bottom: solid 1px #ccc;
  margin-top: 0.1rem;
  padding-bottom: 0.2rem;
}
.lie_img {
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 0.1rem;
}
.lie_img img {
  width: 0.6rem;
  height: 0.6rem;
  float: left;
  border-radius: 5px;
}
.dian_lie p {
  font-size: 0.18rem;
  cursor: pointer;
}
.dian_lie p:hover {
  color: #fe8f24;
}
.centent_right {
  margin-left: 10%;
  width: 66%;
}
.centent_title {
  font-size: 0.34rem;
  border-bottom: solid 1px #000;
  padding: 0.2rem 0;
  text-align: center;
}
.centent_nei {
  font-size: 0.24rem;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Tournament.vue